import React, { useState } from 'react';
import { Modal, View } from 'react-native';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import FormActions from '../../../components/FormActions';
import Toast from 'react-native-toast-message';
import { ClientError } from '../../../services/central-api/base-service';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { appAgentService } from '../../../services/central-api/app-agent';

interface ModalProps {
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    service: Service;
    serviceStatus: boolean;
}

export default function DisableEnableModal({ isModalVisible, setIsModalVisible, service, serviceStatus }: ModalProps) {
    const { styles, theme } = useStyles(styleSheet);

    const [reason, setReason] = useState<string>('');

    function isReasonInvalid(value: string) {
        return value == '';
    }

    function isFormValid() {
        return !isReasonInvalid(reason);
    }

    async function formSubmit() {
        try {
            if (window.AndroidBridge) {

                if (service == 'LocationService' && window.AndroidBridge.setLocationServiceRunning) {
                    window.AndroidBridge.setLocationServiceRunning(!serviceStatus);
                } else if (service == 'LprService' && window.AndroidBridge.setLprServiceRunning) {
                    window.AndroidBridge.setLprServiceRunning(!serviceStatus);
                }
            }
            await appAgentService.updateAgentServiceStatus(service, !serviceStatus, reason);
            clearValue();
            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }

            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    function clearValue() {
        setIsModalVisible(false);
        setReason('');
    }

    return (
        <Modal
            transparent={true}
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => clearValue()}
        >
            <View style={styles.container}>
                <View style={styles.formContainer}>
                    <View style={styles.header}>
                        <MyAppText style={styles.attentionText}>{translate('attention')}!</MyAppText>
                        <FontAwesomeIcon
                            icon={(serviceStatus ? faExclamationTriangle : faCheckCircle) as IconDefinition}
                            fontSize={45}
                            color={serviceStatus ? theme.colors.errors['300'] : theme.colors.successes['300']}
                        />
                        <MyAppText style={{ textAlign: 'center' }}>{translate(serviceStatus ? 'disableServiceReason' : 'enableServiceReason')}</MyAppText>
                    </View>
                    <View>
                        <FormInput
                            label={translate('reason')}
                            placeholder={translate('reason')}
                            value={reason}
                            onChangeText={setReason}
                            invalid={isReasonInvalid}
                            required={true}
                            multiline={true}
                            numberOfLines={3}
                        />
                    </View>
                    <FormActions
                        onSubmit={formSubmit}
                        onClose={() => clearValue()}
                        disabled={!isFormValid()} />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        minHeight: 150,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25,
        justifyContent: 'space-between',
        width: '95%'
    },
    header: {
        flexDirection: 'column',
        gap: 16,
        justifyContent: 'center',
        alignItems: 'center'
    },
    attentionText: {
        fontSize: 18,
        fontWeight: 'bold'
    }
}));
